<div class="dialog-header" *ngIf="!customContent; else customHeaderContent">
  <h4 class="napa-common-dialog-title">{{ config.title }}</h4>

  <napa-square-close-icon (click)="closeDialog.emit()"></napa-square-close-icon>
</div>

<ng-template #customHeaderContent>
  <ng-content select="[napaCustomDialogContent]"></ng-content>
</ng-template>
